import {connect} from 'react-redux';
import {fetchPost} from './../../actions';
import React, {Component} from 'react';
import Post from '../../components/Post/Post';
import utils from '../../utils/utils';

class PostController extends Component {
  static fetchData(dispatch, params) {
    return dispatch(fetchPost(params));
  }

  render() {
    return (
      <Post {...this.props}/>
    );
  }
}

function mapStateToProps(state) {
  const articlesContent = utils.parseItemsContent([state.post.article]);
  state.posts.tag = 'article';
  return {
    loading: state.post.loading,
    article: articlesContent[0]
  };
}

export default connect(mapStateToProps)(PostController);



// WEBPACK FOOTER //
// ./containers/Post/Post.js